import styled from 'styled-components';

export const ScrollTabWrapper = styled.div<{
  direction: string;
  isStickySearch: boolean;
  visible: boolean;
  extraHeight: boolean;
  selectedTab?: boolean;
  shouldResearchPackage: boolean;
  selectedTabHotel?: boolean;
  isDatelessSarch?: boolean;
}>`
  width: 100%;
  height: auto;
  position: fixed;
  transition: all 0.25s;
  background-color: ${({ theme }) => theme.palette.white};
  top: ${({
    visible,
    selectedTab,
    shouldResearchPackage,
    selectedTabHotel,
    isDatelessSarch,
  }) =>
    shouldResearchPackage && visible
      ? '195px'
      : selectedTab && visible && !isDatelessSarch
      ? '155px'
      : selectedTab && visible && isDatelessSarch
      ? '118px'
      : selectedTabHotel && visible
      ? '138px'
      : visible
      ? '97px'
      : '-1000px'};
  box-shadow: rgba(0, 0, 0, 0.1) -1px 20px 10px 0;
  z-index: 999;
  overflow-x: auto;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    z-index: 99;
    top: ${({ isStickySearch, visible, direction }) =>
      visible && !isStickySearch && direction === 'down'
        ? '0'
        : visible && direction === 'up'
        ? '98px'
        : '-100px'};
  }
`;

export const ContainerBorder = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  top: 55%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.lightsSilver};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  z-index: 2300;
  transition: all 0.05s;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  padding: 5px 13px 0 13px;
  justify-content: space-between;

  & a {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.darkGray};
    padding-bottom: 10px;
  }

  & .active {
    color: ${({ theme }) => theme.palette.coral};
    font-weight: bold;
    border-bottom: 4px solid ${({ theme }) => theme.palette.coral};
    padding-bottom: 10px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow-x: auto;
    white-space: nowrap;

    width: 100vw;
    margin: 0;
    max-width: unset;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
    & a {
      padding-right: 0;
      padding-bottom: 14px;

      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }
`;
